<template>
  <el-container>
    <el-main style="padding: 0">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="inStockBills"
          :search-more-show="true"
          @select="select"
          @select-all="select"
          @update:filter="handleClick"
          @searchShow="searchShow = !searchShow">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="入库单号：">
              <el-input v-model.trim="filter.billNo" placeholder="请输入入库单号" clearable/>
            </vm-search>
            <vm-search label="关联单据：">
              <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
            </vm-search>
            <vm-search label="订单状态：">
              <el-select v-model="filter.status" placeholder="请选择状态" clearable>
                <el-option label="未提交" :value="0"/>
                <el-option label="已提交" :value="1"/>
                <el-option label="已入库" :value="2"/>
              </el-select>
            </vm-search>
          </div>
          <div v-show="searchShow">
            <vm-search label="到货日期：">
              <div class="block">
                <el-date-picker
                    v-model="receiptTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                    @change="receiptTimeChange"/>
              </div>
            </vm-search>
            <vm-search label="制单时间：">
              <div class="block">
                <el-date-picker
                    v-model="createTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                    @change="createTimeChange"/>
              </div>
            </vm-search>
          </div>
        </template>
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)"> 新建 </el-button>
          <el-button :disabled="!selection.length" type="primary" @click="suspend">提交</el-button>
          <el-button :disabled="!selection.length" type="primary" @click="cancelSuspend">撤销</el-button>
          <el-button :disabled="!selection.length" type="primary" @click="printInStockOrder">打印入库单</el-button>
          <el-button :disabled="!selection.length" type="danger" @click="deleteRows">批量删除</el-button>
        </div>
        <el-table-column
            type="selection"
            label="#"
            align="center"
            width="55"
            prop="selection"/>
        <el-table-column prop="billNo" align="center" label="入库单号" width="120"/>
        <el-table-column prop="inStockTypeName" align="center" label="入库类型" width="130"/>
        <el-table-column prop="relBillNo" align="center" label="关联单据编号" width="180"/>
        <el-table-column prop="statusName" align="center" label="订单状态" width="100"/>
        <el-table-column prop="receiptDate" align="center" label="到货日期" width="150">
          <template slot-scope="scope">
            <span v-if="!scope.row.receiptDate">{{scope.row.receiptDate}}</span>
            <span v-else>{{scope.row.receiptDate.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="制单时间" width="150"/>
        <el-table-column prop="creatorName" align="center" label="制单人" width="100"/>
        <el-table-column
            prop="note"
            align="left"
            label="备注"
            show-overflow-tooltip
            min-width="110"/>
        <el-table-column
            label="操作"
            align="center"
            fixed="right"
            class-name="vm-table_operate"
            prop="action"
            width="160">
          <template slot-scope="scope">
            <el-button type="primary" :disabled="scope.row.status === 2 || scope.row.status === 1" @click="$refs.editPage.open(scope.row.pkid)"> 编辑 </el-button>
            <el-button type="warning" @click="$refs.editPage.open(scope.row.pkid, true)"> 详情 </el-button>
            <el-button type="danger" :disabled="scope.row.status === 2 || scope.row.status === 1" @click="deleteRow(scope.row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <production-storage-edit ref="editPage" @save-success="getList(1)"/>
      <print-in-stock-order-modal ref="printInStockOrder"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import PrintInStockOrderModal from "./PrintStorageOrder.vue";
  import ProductionStorageEdit from "./ProductionStorageEdit";
  export default {
    name: "StorageOrderIndex",
    components: { VmTable, VmSearch, ProductionStorageEdit, PrintInStockOrderModal },
    data() {
      return {
        searchShow: false,
        receiptTime: [],
        createTime: [],
        ids: [],
        selection: [],
        flag: true,
        billStatus: [],
        filter: {
          billNo: "",
          relBillNo: "",
          status: "",
          inStockType: 1,
          supplierId: "",
          receiptDateFrom: "",
          receiptDateTo: "",
          createTimeBegin: "",
          createTimeEnd: "",
        },
      };
    },

    mounted() {
      this.$refs.vmTable.getList(1);
    },

    methods: {
      //获取列表数据
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      //选择
      select(selection) {
        this.selection = selection;
      },

      //监测制单时间用户输入变化并赋值
      createTimeChange(val) {
        if (val) {
          this.filter.createDateFrom = val[0];
          this.filter.createDateTo = val[1];
        } else {
          this.filter.createDateFrom = "";
          this.filter.createDateTo = "";
        }
      },

      //监测收货时间用户输入变化并赋值
      receiptTimeChange(val) {
        if (val) {
          this.filter.receiptDateFrom = val[0];
          this.filter.receiptDateTo = val[1];
        } else {
          this.filter.receiptDateFrom = "";
          this.filter.receiptDateTo = "";
        }
      },

      //订单提交
      suspend() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
            this.$http.post("basic", "inStockBills/submit", ids).then(() => {
              this.getList(1);
              this.$message.success("提交成功");
            });
          });
        }
      },

      //撤销方法
      cancelSuspend() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.$confirm("确定撤销吗?", "提示", { type: "warning" }).then(() => {
            this.$http.post("basic", "inStockBills/cancel", ids).then(() => {
              this.getList(1);
              this.$message.success("撤销成功");
            });
          });
        }
      },

      //打印入库单
      printInStockOrder() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          return this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$refs.printInStockOrder.open(ids);
      },
      // 单个删除
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "inStockBills", row.pkid).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
            }
          });
        });
      },
      //批量删除
      deleteRows() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "inStockBills/deleteBatch", ids).then(() => {
            this.getList(1);
            this.$message.success("删除成功");
          });
        });
      },

      // 点击重置需要重置日期查询(注意)
      handleClick() {
        this.receiptTime = [];
        this.createTime = [];
      },
    },
  };
</script>
